import { uuidv7, type Clock, type RandomSource } from '@cadencia/domain';

/** Adaptadores del navegador para el dominio, que es puro (ADR-007). */
export const systemClock: Clock = {
  now: () => Date.now(),
  nowIso: () => new Date().toISOString(),
};

export const cryptoRandom: RandomSource = {
  next: () => {
    const buffer = new Uint32Array(1);
    globalThis.crypto.getRandomValues(buffer);
    return (buffer[0] ?? 0) / 0x1_0000_0000;
  },
};

export function newId(): string {
  return uuidv7(systemClock, cryptoRandom);
}

export function nowIso(): string {
  return systemClock.nowIso();
}
